export default __webpack_public_path__ + "static/media/hero.bdd109ce.jpeg";